import { render } from "./international-download.vue?vue&type=template&id=2028b8aa&scoped=true"
const script = {}

import "./international-download.vue?vue&type=style&index=0&id=2028b8aa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2028b8aa"]])

export default __exports__